import { Fragment } from 'react';
import { useTheme } from '@mui/material/styles';
import ExitButton from 'components/button/ExitButton';
import ActionButton from 'components/button/ActionButton';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

const ConfirmModal = ({ showModal, setShowModal, setSubmitForm = () => {}, modalData, handleSubmit = () => {} }) => {
	const theme = useTheme();

	const handleOk = () => {
		setSubmitForm(true);

		handleSubmit();
		setShowModal(false);
	};
	const handleClose = () => {
		setShowModal(false);
	};

	return (
		<Fragment>
			<Dialog
				keepMounted
				maxWidth={'sm'}
				fullWidth={true}
				open={showModal}
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{
					// old: '.MuiPaper-root': { borderRadius: '4px' }
					'.MuiPaper-root': {
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
						overflow: 'hidden',
					},
				}}
			>
				<Box>
					<Grid
						container
						spacing={2}
						alignItems="center"
						justifyContent="space-between"
						sx={{
							bgcolor: '#F8FAFC',
							borderBottom: `1px solid ${theme.palette.divider}`,
						}}
					>
						<Grid item>
							<DialogTitle sx={{ color: '#0F172A', display: 'flex', alignItems: 'center' }}>
								{modalData?.head ?? ''}
							</DialogTitle>
						</Grid>

						<Grid item sx={{ mr: 3 }}>
							<ExitButton handleClose={handleClose} color="#64748B" />
						</Grid>
					</Grid>

					<DialogContent sx={{ pt: { xs: 7, md: 10 }, pb: { xs: 5, md: 7 } }}>
						<Typography variant="h6" align="center">
							{modalData?.label ? modalData?.label : 'Do you want to proceed?'}
						</Typography>
					</DialogContent>

					<DialogActions sx={{ px: 3, pb: 3, display: 'flex', justifyContent: 'center' }}>
						<ActionButton label="Yes" variantType="yes" onClick={handleOk} />
						<ActionButton label="No" variantType="no" onClick={handleClose} />
					</DialogActions>
				</Box>
			</Dialog>
		</Fragment>
	);
};

export default ConfirmModal;
